<template>
  <home />
</template>
<script>
import Home from '@/components/home/index.vue'
export default {
  components: { Home }
}
</script>
